import React, { useEffect, useState } from "react";
import BetSlipContext from "../../../context/BetSlipContext";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../../context/AuthContext";
import { inRange, isEmpty } from "lodash";

const BetSlipSkyWeb = () => {
  const numberArray = [10, 100, 200, 500, 10000, 20000];

  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const setBetSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setBetSlipObject;
  });
  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });
  const betLoader = useContextSelector(AuthContext, (ctx) => {
    return ctx.betLoader;
  });
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });

  const limit = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.limit;
  });
  const setShowBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setShowBetDialog;
  });

  const setResetBetPosition = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setResetBetPosition;
  });
  const handelPlaceBetFair = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceBetFair;
  });
  const handelPlaceFancy = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceFancy;
  });
  const handelPlaceBookmaker = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceBookmaker;
  });
  const setLoginModal = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setLoginModal;
  });
  const handelPlaceSportBook = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceSportBook;
  });

  const handelPlaceToss = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceToss;
  });
  const [bidPriceDisabled, setBidPricDisabled] = useState(true);
  const [timeLeft, setTimeLeft] = useState(limit?.betDelay);
  useEffect(() => {
    if (
      inRange(
        Number(betSlipObject?.bidPrice),
        limit?.minAmount || 1,
        limit?.maxAmount + 1 || 100
      )
    ) {
      setBidPricDisabled(false);
    } else {
      setBidPricDisabled(true);
    }
  }, [betSlipObject, limit]);
  const placeBet = () => {
    if (!isEmpty(user)) {
      if (
        betSlipObject?.playType == "betFaire" ||
        betSlipObject?.playType == "multi" ||
        betSlipObject?.playType == "home"
      ) {
        handelPlaceBetFair();
      } else if (betSlipObject?.playType == "fancy") {
        handelPlaceFancy();
      } else if (betSlipObject?.playType == "bookmaker") {
        handelPlaceBookmaker();
      } else if (betSlipObject?.playType == "sportBook") {
        handelPlaceSportBook();
      } else if (betSlipObject?.playType == "toss") {
        handelPlaceToss();
      }
    } else {
      setShowBetDialog(false);
      setLoginModal(true);
    }
  };

  useEffect(() => {
    if (betLoader) {
      if (timeLeft <= 0) return;

      const interval = setInterval(() => {
        setTimeLeft((t) => t - 1);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [timeLeft, betLoader]);
  return betLoader ? (
    <tr className="fancy-quick-tr">
      <td colSpan={7}>
        {" "}
        <dl className="quick_bet-wrap quick_bet-progress">
          <dd
            id="progressBar"
            className="progress-bar"
            style={{ width: "100%" }}
          />
          <dd className="progress-bar-txt">
            Placing your bets, Please wait{" "}
            <span id="secRemain">{timeLeft} sec remaining…</span>
          </dd>
        </dl>
      </td>
    </tr>
  ) : (
    <tr className="fancy-quick-tr">
      <td colSpan={7}>
        <dl
          id="classWrap"
          className={`quick_bet-wrap slip-${betSlipObject?.playType == "sportBook"
              ? "book"
              : ["lay", "No"].includes(betSlipObject?.betType)
                ? "lay"
                : "back"
            }`}
        >
          <dt id="fancyBetHeader" className>
            <span id="fancyBetAcceptCheck" className="bet-check">
              <input id="fancyBetAcceptAnyOdds" type="checkbox" />
              <label htmlFor="fancyBetAcceptAnyOdds">Accept Any Odds</label>
            </span>
          </dt>
          <dd
            onClick={() => {
              setShowBetDialog(false);
              setResetBetPosition(true);
            }}
            className="col-btn"
          >
            <a id="cancel" className="btn" style={{ cursor: "pointer" }}>
              Cancel
            </a>
          </dd>
          <dd id="oddsHeader" className="col-odd">
            <ul className="quick-bet-confirm">
              <li id="runs">{betSlipObject?.odds}</li>
              {["fancy"].includes(betSlipObject?.playType) && (
                <li id="odds" className="quick-bet-confirm-title">
                  {betSlipObject?.object?.pt}
                </li>
              )}
            </ul>
          </dd>
          <dd className="col-stake">
            <input
              id="inputStake"
              type="text"
              value={betSlipObject?.bidPrice}
            />
          </dd>
          <dd
            onClick={() => {
              placeBet();
            }}
            className="col-send"
          >
            <a
              id="placeBet"
              className={`btn-send ${bidPriceDisabled ? "disable" : ""} `}
              style={{ cursor: "pointer" }}
            >
              Place Bets
            </a>
          </dd>
          <dd
            id="stakePopupList"
            className="col-stake_list"
            stakepopuplisttype="extended"
            style={{ display: "block" }}
            fancybetboard="fancyBetBoard_34948814_2680282_2"
          >
            <ul>
              {(profileData?.stake?.length > 0
                ? profileData?.stake?.sort(function (a, b) {
                  return a - b;
                })
                : numberArray
              )
                ?.slice(0, 6)
                ?.map((res) => {
                  return (
                    <li
                      onClick={() => {
                        setBetSlipObject({
                          ...betSlipObject,
                          bidPrice: Number(res),
                        });
                      }}
                    >
                      <a
                        className="btn"
                        id="selectStake_1"
                        style={{ cursor: "pointer" }}
                      >
                        {res}
                      </a>
                    </li>
                  );
                })}
            </ul>
            <p id="totalStakeP" style={{ display: "none" }}>
              Total Stake: <strong id="totalStake" />
            </p>
          </dd>
        </dl>
      </td>
    </tr>
  );
};

export default BetSlipSkyWeb;
